module.exports = __webpack_public_path__ + "img/section.e504d881.svg";